import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EditProductAlertPage = lazy(() =>
  import("@scenes/ProductAlerts/components/EditProductAlertPage").then((module) => ({
    default: module.EditProductAlertPage,
  }))
);

export const productAlertsEditNRO: NavigationRoutingObject = {
  Component: EditProductAlertPage,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("product-alerts-edit-nro-heading", "Product Alerts"),
  pageNameForTracking: () => "Edit Product Alert",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return featureOn("product_alerts") && hasPermission("appGroup", { permission: "viewCanvases" });
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/product_alerts/:appGroupId",
};
